import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { AddRollCallApi } from "../../../api";
import {  convertStringDateToDateSupport } from "../../../utils";
import { useNavigate, Link } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

export const RollcallAdd = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxDash = useContext(ContextDashboard)
    const CtxLoad = useContext(ContextLoading)
    const [defualtDate, setDefualtDate] = useState<any>(null);

    const onChangeValueDate = (e: any, type: string) => {
        let data = { ...defualtDate };
        data[`${type}_date`] = convertStringDateToDateSupport(e?.toDate?.().toString());
        setDefualtDate(data)
    }

    const onFinishAdd = async (e: any) => {
        e.preventDefault()
        if(defualtDate == null || !defualtDate.start_date) return toast("انتخاب تاریخ ورود الزامیست", { type: "error" })
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await AddRollCallApi(formRef, defualtDate)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast(res.message, { type: "success" })
            navigate('/p/reports/rollcall');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }

    useEffect(() => {
        document.title = "افزودن تردد | دایان"
        CtxNav.setActiveMenuItem({ 'item': 1, 'subItem': 0, })
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">افزودن تردد پرسنل</h1>

            <form ref={formRef} onSubmit={onFinishAdd} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">

                <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                        <svg x="0px" y="0px" viewBox={'0 0 512 512'} className={`  h-5 'fill-dayan-gray-100' `}>
                            <use xlinkHref="/assetes/svg/person.svg#person" />
                        </svg>
                        <span className="text-[11px] mr-3">مشخصات پرسنل</span>
                    </div>
                    <div className=" w-full md:w-10/12  flex items-center">
                        <div className=" w-[50%] h-[50px] pl-1 sm:pl-2">
                            <CSelect name="employee" placeholder={'انتخاب کارمند'} title="نام پرسنل" border={true} required={true}>
                                {CtxDash.employees?.map((item: any, index: number) =>
                                    <option key={index} value={item.id}>{item.name}</option>
                                )}
                            </CSelect>
                        </div>
                        <div className=" w-[50%] h-[50px] pr1 sm:pr-2">
                            <CSelect name="location" placeholder={'انتخاب موقعیت مکانی'} title="موقعیت مکانی" border={true} required={true}>
                                {CtxDash.location?.map((item: any, index: number) =>
                                    <option key={index} value={item.id}>{item.name}</option>
                                )}
                            </CSelect>
                        </div>
                    </div>
                </div>

                <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                        <svg x="0px" y="0px" viewBox={'0 0 24 24'} className={`  h-5 'fill-dayan-gray-100' `}>
                            <use xlinkHref="/assetes/svg/exit.svg#exit" />
                        </svg>
                        <span className="text-[11px] mr-3">تاریخ و ساعت ورود </span>
                    </div>
                    <div className=" w-full md:w-10/12  flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex  items-center pl-0 sm:pl-2">
                            <div className=" w-[50%] h-full pl-1">
                                <CSelect name="start_hours" placeholder={'ساعت'} title="ساعت" border={true} required={true}>
                                    {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'].map((item: any, index: number) =>
                                        <option key={index} value={item}>{item}</option>
                                    )}
                                </CSelect>
                            </div>
                            <div className=" w-[50%] h-full pr-1">
                                <CSelect name="start_min" placeholder={'دقیقه'} title="دقیقه" border={true} required={true}>
                                    {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'].map((item: any, index: number) =>
                                        <option key={index} value={item}>{item}</option>
                                    )}
                                </CSelect>
                            </div>
                        </div>
                        <div className=" w-full sm:w-[50%] h-[50px] sm:mt-0 mt-5 pr-0 sm:pr-2">
                            <div className={` flex relative px-[7px] h-full rounded-[5px] items-center mb-[3px] border border-dayan-gray-100`}>
                                <span className="text-[12px] text-dayan-gray-100 absolute bg-white top-[-12px] right-[15px] px-[10px]">تاریخ ورود</span>
                                <div className={` jalali-datePicker flex items-center justify-center w-full h-full bg-transparent px-[10px] sm:text-[13px] text-[11px]`} >
                                    <DatePicker calendar={persian} locale={persian_fa} onChange={(e: any) => { onChangeValueDate(e, 'start') }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="md:w-10/12 w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px]  pb-[15px] sm:pb-[30px]">
                    <div className=" w-full md:w-2/12 h-[50px] flex items-center md:mb-0 mb-1">
                        <svg x="0px" y="0px" viewBox={'0 0 24 24'} className={`  h-5 'fill-dayan-gray-100' `}>
                            <use xlinkHref="/assetes/svg/exit.svg#exit" />
                        </svg>
                        <span className="text-[11px] mr-3">تاریخ و ساعت خروج </span>
                    </div>
                    <div className=" w-full md:w-10/12  flex flex-col sm:flex-row items-center">
                        <div className=" w-full sm:w-[50%] h-[50px] flex  items-center pl-0 sm:pl-2">
                            <div className=" w-[50%] h-full pl-1">
                                <CSelect name="end_hours" placeholder={'ساعت'} title="ساعت" border={true} >
                                    {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'].map((item: any, index: number) =>
                                        <option key={index} value={item}>{item}</option>
                                    )}
                                </CSelect>
                            </div>
                            <div className=" w-[50%] h-full pr-1">
                                <CSelect name="end_min" placeholder={'دقیقه'} title="دقیقه" border={true} >
                                    {['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'].map((item: any, index: number) =>
                                        <option key={index} value={item}>{item}</option>
                                    )}
                                </CSelect>
                            </div>
                        </div>
                        <div className=" w-full sm:w-[50%] h-[50px] sm:mt-0 mt-5 pr-0 sm:pr-2">
                            <div className={` flex relative px-[7px] h-full rounded-[5px] items-center mb-[3px] border border-dayan-gray-100`}>
                                <span className="text-[12px] text-dayan-gray-100 absolute bg-white top-[-12px] right-[15px] px-[10px]">تاریخ خروج</span>
                                <div className={` jalali-datePicker flex items-center justify-center w-full h-full bg-transparent px-[10px] sm:text-[13px] text-[11px]`} >
                                    <DatePicker calendar={persian} locale={persian_fa} onChange={(e: any) => { onChangeValueDate(e, 'end') }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/reports/rollcall'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>

        </div>
    )
}